// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    PostIntelligentCoursePartnerHomePageStudentTaskTrendBody,
    BaseResponseListIntelligentPartnerHomePageCourseScoresTrend,
} from '../../../../types';

/**
 * 学员端任务趋势接口
 *
 * @export
 * @tags 智能陪练课程总览接口
 * @link [POST] /intelligentCoursePartner/homePage/student/taskTrend
 */
export function postIntelligentCoursePartnerHomePageStudentTaskTrend(
    data: PostIntelligentCoursePartnerHomePageStudentTaskTrendBody
): Promise<BaseResponseListIntelligentPartnerHomePageCourseScoresTrend>;
export function postIntelligentCoursePartnerHomePageStudentTaskTrend(
    data: PostIntelligentCoursePartnerHomePageStudentTaskTrendBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageCourseScoresTrend>;
export function postIntelligentCoursePartnerHomePageStudentTaskTrend(
    data: PostIntelligentCoursePartnerHomePageStudentTaskTrendBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListIntelligentPartnerHomePageCourseScoresTrend> {
    return request<PostIntelligentCoursePartnerHomePageStudentTaskTrendBody, never, never>(
        '/intelligentCoursePartner/homePage/student/taskTrend',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentCoursePartnerHomePageStudentTaskTrend',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练课程总览接口'],
        path: '/intelligentCoursePartner/homePage/student/taskTrend',
        method: 'post',
    },
];
